// extracted by mini-css-extract-plugin
module.exports = {"navMenu":"index_navMenu_2Uo6f","menu":"index_menu_3baYs","menuItem":"index_menuItem_1aaG1","openMenu":"index_openMenu_4yHUj"};